import { Skeleton } from "@elit-hair/elit-ui";

export function HeaderKpiSkeleton() {
    return (
        <div className="flex items-center gap-1 border border-border rounded-md p-2" aria-label="KPI metrics">
            <Skeleton className="h-4 w-6" />
            <Skeleton className="h-4 w-4" />
        </div>
    );
}
